import { DateTime } from "luxon";

const maxLengthX = (v, x) => typeof v === "string" && v.length <= x;
const minLengthX = (v, x) => typeof v === "string" && v.length >= x;

export const validators = {
  maxlen16: v => maxLengthX(v, 16),
  minlen16: v => minLengthX(v, 16),
  required: v => v !== undefined && v !== null && String(v).trim() !== "",
  // Matches transform output and server date parsing (dd-MM-yyyy).
  date: v => {
    if (v === undefined || v === null || String(v).trim() === "") return false;
    return DateTime.fromFormat(String(v).trim(), "dd-MM-yyyy").isValid;
  },
  // 24-hour HH:mm:ss — same shape emitted by CSV time transforms.
  time: v => {
    if (v === undefined || v === null || String(v).trim() === "") return false;
    return /^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(String(v).trim());
  },
  string: v => typeof v === "string",
  number: v => {
    if (v === undefined || v === null || String(v).trim() === "") return false;
    return Number.isFinite(Number(v));
  },
  uid: v => typeof v === "string" && v.length === 16,
  // Backend batch create only treats uppercase TRUE as true.
  boolean: v => {
    if (typeof v === "boolean") return true;
    if (v === undefined || v === null) return false;
    const normalized = String(v).trim().toUpperCase();
    return normalized === "TRUE" || normalized === "FALSE";
  },
  json: v => {
    if (v === undefined || v === null || String(v).trim() === "") return false;
    try {
      JSON.parse(v);
      return true;
    } catch {
      return false;
    }
  },
};
